export default "__VITE_ASSET__CbOjq_Yy__"